import React from 'react';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import ActionButton from 'components/shared/ActionButton';
import {
  sendExportKnowledgeCheckAttemptsRequest,
  sendExportAllActivitiesRequest,
} from 'misc/async_reports_helper';
import DataCard from '../_shared/DataCard';
import TagReportsContainer from '../Tags/TagReportsContainer';
import OnDemandPracticeReportsContainer from '../OnDemandPractice/OnDemandPracticeReportsContainer';
import SmsReportsContainer from '../Sms/SmsReportsContainer';
import { useHasSelectedFilters } from '../Filters/HasFilters';
import InPersonTrainingReportContainer from '../InPersonTraining/InPersonTrainingReportContainer';
import PracticeFeedbackReportsContainer from '../PracticeFeedback/PracticeFeedbackReportsContainer';
import CertificationsReport from '../CertificationsReport/CertificationsReport';

const MoreReportsContainer = ({ permissions }) => {
  const hasSelectedFilters = useHasSelectedFilters();

  return (
    <>
      {!hasSelectedFilters && (
        <DataCard.Container direction="column">
          <DataCard.Content
            title={t('insights.events.title')}
            subtitle={t('insights.events.subtitle')}
            labsBadgeDescription={t('insights.more_reports.description')}
          >
            <ActionButton
              label={t('common.email_download_link')}
              handleClick={e => sendExportAllActivitiesRequest()}
              iconName="download"
              customButtonStyles="u-linkBtn c-p DataCard-link"
              pendoClassName="trk_link_learning_all-activities-report-download"
            />
          </DataCard.Content>
          {permissions.allLessonsReport && (
            <DataCard.Content
              title={t('insights.lessons.title')}
              subtitle={
                <>
                  {t('insights.lessons.subtitle')}
                  <br />
                  <br />
                  {t('insights.lessons.note')}
                </>
              }
              labsBadgeDescription={t('insights.more_reports.description')}
            >
              <a
                href={routes.INSIGHTS.ALL_LESSONS_REPORT}
                className="DataCard-link"
              >
                <Icon name="download" /> {t('common.download')}
              </a>
            </DataCard.Content>
          )}
        </DataCard.Container>
      )}
      <CertificationsReport />
      {!hasSelectedFilters && !permissions.searches && (
        <DataCard.Container direction="column">
          <DataCard.Content
            title={t('insights.search_summary.title')}
            subtitle={t('insights.search_summary.subtitle')}
            labsBadgeDescription={t('insights.more_reports.description')}
          >
            <a href={routes.INSIGHTS.SEARCH.REPORT} className="DataCard-link">
              <Icon name="download" /> {t('common.download')}
            </a>
          </DataCard.Content>
        </DataCard.Container>
      )}
      {!hasSelectedFilters && permissions.knowledgeCheckAttempts && (
        <DataCard.Container direction="column">
          <DataCard.Content
            title={t('insights.knowledge_checks.attempts.title')}
            subtitle={t('insights.knowledge_checks.attempts.subtitle')}
            labsBadgeDescription={t('insights.more_reports.description')}
          >
            <ActionButton
              label={t('common.email_download_link')}
              handleClick={e => sendExportKnowledgeCheckAttemptsRequest()}
              iconName="download"
              customButtonStyles="u-linkBtn c-p DataCard-link"
              pendoClassName="trk_link_learning_knowledge-check-attempts-download"
            />
          </DataCard.Content>
          <DataCard.Content
            title={t('insights.knowledge_checks.correctness.title')}
            subtitle={t('insights.knowledge_checks.correctness.subtitle')}
            labsBadgeDescription={t('insights.more_reports.description')}
          >
            <a
              href={routes.INSIGHTS.KNOWLEDGE_CHECKS.CORRECTNESS_REPORT}
              className="DataCard-link trk_link_learning_knowledge-check-correctness-download"
            >
              <Icon name="download" /> {t('common.download')}
            </a>
          </DataCard.Content>
        </DataCard.Container>
      )}
      {!hasSelectedFilters && permissions.tagData && <TagReportsContainer />}
      {!hasSelectedFilters && permissions.onDemandPractice && (
        <OnDemandPracticeReportsContainer />
      )}
      {!hasSelectedFilters && permissions.practice && (
        <PracticeFeedbackReportsContainer />
      )}

      {permissions.sms && <SmsReportsContainer />}
      {permissions.inPersonTraining && <InPersonTrainingReportContainer />}
    </>
  );
};

export default MoreReportsContainer;
